'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mutations = {
  // ********* //
  // LENS DATA //
  // ********* //

  // Setting lens data
  setLenses: function setLenses(state, data) {
    data.map(function (lens) {
      var isNonPrescription = lens.tags.includes('no prescription');
      var isDefault = lens.variants[0].title === 'Default Title';

      if (lens.variants.length > 1 || !isDefault && !isNonPrescription) {
        lens.steps = 3;
      } else if (isNonPrescription) {
        lens.steps = 1;
      } else {
        lens.steps = 2;
      }
    });

    state.lenses = data;
  },

  // Set frame product
  setFrame: function setFrame(state, data) {
    state.frame = data;
  },

  // Identifying nonprescription lens product
  setNonPrescriptionLens: function setNonPrescriptionLens(state, data) {
    state.nonPrescriptionLens = data;
  },

  // Setting active filtered group 
  setActiveLenses: function setActiveLenses(state, data) {
    state.activeLenses = data;
  },

  // Setting specific lens product
  setFinalLens: function setFinalLens(state, data) {
    state.finalLens = data;
  },

  // Setting final variant
  setFinalVariant: function setFinalVariant(state, data) {
    state.finalVariant = data;
  },

  // ***************** //
  // PRESCRIPTION DATA //
  // ***************** //

  // Set prescription
  setPrescription: function setPrescription(state, data) {
    state.activePrescription = data;
  },
  setPastPrescriptions: function setPastPrescriptions(state, data) {
    state.prescriptions = data;
  },
  setGrabPrescriptions: function setGrabPrescriptions(state, data) {
    state.grabPrescriptions = data;
  },

  // ************* //
  // GENERAL STATE //
  // ************* //
  showModule: function showModule(state) {
    state.showPrescriptionModule = true;
  },
  hideModule: function hideModule(state) {
    state.showPrescriptionModule = false;
  },
  setStep: function setStep(state, data) {
    state.step = data;
  },
  setFrameOptions: function setFrameOptions(state, data) {
    state.options = data;
  },
  setOptionMeta: function setOptionMeta(state, data) {
    state.meta = data;
  },
  setTotalPrice: function setTotalPrice(state, data) {
    state.totalPrice = data;
  },
  setCms: function setCms(state, data) {
    state.cms = data;
  }
};

exports.default = mutations;